import { render, staticRenderFns } from "./navigation-bar-h5.vue?vue&type=template&id=68a37bea&scoped=true"
import script from "./navigation-bar-h5.vue?vue&type=script&lang=js"
export * from "./navigation-bar-h5.vue?vue&type=script&lang=js"
import style0 from "./navigation-bar-h5.vue?vue&type=style&index=0&id=68a37bea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a37bea",
  null
  
)

export default component.exports